export default () => ({
    event: {},
    loading: false,
    error: false,
    socialResponsibilities:{},
    blog:{},
    projects:{},
    single:{},
    gallery:{},
    eventCat:{},
    topic_comments:{}
});
